import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/components/landingPage/index'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Landing page',
			component: LandingPage
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js